import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLineMts = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M24 12.0608C24 5.39997 18.4203 -0.000335693 12.0303 -0.000335693C5.40043 -0.000335693 0 5.39997 0 12.0608C0 18.6606 5.40043 24 12.0303 24C18.6602 24 24 18.6905 24 12.0608ZM22.3501 12.0608C22.3501 17.7007 17.7009 22.4105 12.0303 22.4105C6.32996 22.4105 1.64977 17.7603 1.64977 12.0608C1.64977 6.32926 6.32995 1.59049 12.0303 1.59049C17.7009 1.59049 22.3501 6.36061 22.3501 12.0608ZM17.9703 17.3705V6.89997C17.9703 6.29982 17.6407 5.66979 16.6507 5.66979C15.9007 5.66979 15.6004 5.99967 15.2701 6.65988L12.0303 13.4105H11.9995L8.73098 6.65988C8.4003 5.99967 8.0997 5.66979 7.34993 5.66979C6.35963 5.66979 6.03003 6.29982 6.03003 6.89997V17.3705C6.03003 17.9403 6.48032 18.2708 7.02012 18.2708C7.50095 18.2708 8.03979 17.9403 8.03979 17.3705V9.57037H8.0702L11.0403 15.6302C11.2499 16.05 11.5198 16.2901 11.9995 16.2901C12.48 16.2901 12.7499 16.05 12.9597 15.6302L15.9308 9.57037H15.9605V17.3705C15.9605 17.9403 16.4997 18.2708 16.9807 18.2708C17.5198 18.2708 17.9703 17.9403 17.9703 17.3705Z",
				fill: "#0A0082"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 24,
				height: 24,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgLineMts);
export { ForwardRef as ReactComponent };
